/*
* OfferValuesReducer
*/

import { fromJS } from 'immutable';
import {
  SET_OFFER_DEPOSIT,
  SET_OFFER_DISTANCE,
  SET_OFFER_DURATION,
  SET_OFFER_NOTES,
  SET_OFFER_PRIVATE_NOTES,
  SET_OFFER_REFERENCE,
  SET_OFFER_RIGHT_LABEL,
  SET_OFFER_MONTHLY_RATE,
  SET_OFFER_FAST_DELIVERY,
  SET_OFFER_DELIVERY_TIME,
  SET_OFFER_DELIVERY_TIMES,
  SET_OFFER_BROKERS,
  SET_OFFER_BROKER,
  SET_OFFER_PRODUCTS,
  SET_OFFER_PRODUCT,
  VALIDATE_USER_INPUT,
  SET_ERROR_MESSAGE,
  RESET,
} from './constants';
import {
  DISTANCE_YEARS_RANGE,
  DURATION_RANGE,
} from 'containers/App/constants';

// The initial state of the App
export const initialState = fromJS({
  monthlyRate: null,
  duration: DURATION_RANGE.min * 3,
  distance: DISTANCE_YEARS_RANGE.min * 15,
  deposit: null,
  rightLabel: {},
  fastDelivery: false,
  deliveryTime: '',
  deliveryTimes: [],
  brokers: [],
  broker: null,
  products: [],
  product: null,
  hasError: false,
  errorMsg: '',
});

function offerValueReducer(state = initialState, action) {
  switch (action.type) {
    case SET_OFFER_MONTHLY_RATE:
      return state.set('monthlyRate', action.monthlyRate);
    case SET_OFFER_DURATION:
      return state.set('duration', action.duration);
    case SET_OFFER_NOTES:
      return state.set('notes', action.notes);
    case SET_OFFER_PRIVATE_NOTES:
      return state.set('private_notes', action.private_notes);
    case SET_OFFER_REFERENCE:
      return state.set('reference_code', action.reference);
    case SET_OFFER_RIGHT_LABEL:
      return state.set('rightLabel', {key: action.key, label: action.label});
    case SET_OFFER_DISTANCE:
      return state.set('distance', action.distance);
    case SET_OFFER_DEPOSIT:
      return state.set('deposit', action.deposit);
    case SET_OFFER_FAST_DELIVERY:
      return state.set('fastDelivery', action.fastDelivery);
    case SET_OFFER_DELIVERY_TIME:
      return state.set('deliveryTime', action.deliveryTime);
    case SET_OFFER_DELIVERY_TIMES:
      return state.set('deliveryTimes', action.deliveryTimes);
    case SET_OFFER_BROKERS:
      return state.set('brokers', action.brokers);
    case SET_OFFER_BROKER:
      return state.set('broker', action.broker).set('product', null);
    case SET_OFFER_PRODUCTS:
      return state.set('products', action.products);
    case SET_OFFER_PRODUCT:
      return state.set('product', action.product);
    case VALIDATE_USER_INPUT:
      return state.set('hasError', action.hasError);
    case SET_ERROR_MESSAGE:
      return state.set('errorMsg', action.msg);
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default offerValueReducer;
